export const TRANSLATION_DICT_GET_ACTION_INIT = 'TRANSLATION_TOKEN_ACTION_INIT'
export const TRANSLATION_DICT_GET_ACTION_ERROR =
  'TRANSLATION_TOKEN_ACTION_ERROR'
export const TRANSLATION_DICT_GET_ACTION_SUCCESS =
  'TRANSLATION_TOKEN_ACTION_SUCCESS'
export const TRANSLATION_DICT_GET_ACTION_RESET =
  'TRANSLATION_TOKEN_ACTION_RESET'
export const TRANSLATION_LANG_SET_ACTION = 'TRANSLATION_LANG_SET_ACTION'
